module.exports = __webpack_public_path__ + "static/media/hourglass-start.6bc59a7d.svg";